import { useState } from 'react';
import { X } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function LeadCaptureModal({ isOpen, onClose, deckType, downloadUrl }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !email.trim()) {
      setError('Please fill in both fields');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API}/api/leads`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: name.trim(), email: email.trim(), deck_type: deckType })
      });
      if (!res.ok) throw new Error('Failed to submit');
      // Trigger download via hidden link to avoid popup blockers
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      onClose();
      setName('');
      setEmail('');
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="lead-capture-modal">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-[#0a0f0a] border border-emerald-500/30 rounded-2xl p-8 w-full max-w-md shadow-2xl shadow-emerald-500/10">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white transition"
          data-testid="lead-modal-close"
        >
          <X size={20} />
        </button>

        <h3 className="text-2xl font-bold text-white mb-2">Download Pitch Deck</h3>
        <p className="text-gray-400 text-sm mb-6">Enter your details to get instant access to the deck.</p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <input
              type="text"
              placeholder="Your Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-emerald-500 transition"
              data-testid="lead-name-input"
            />
          </div>
          <div>
            <input
              type="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-emerald-500 transition"
              data-testid="lead-email-input"
            />
          </div>

          {error && <p className="text-red-400 text-sm" data-testid="lead-error">{error}</p>}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 bg-emerald-500 hover:bg-emerald-400 text-black font-bold rounded-lg transition disabled:opacity-50"
            data-testid="lead-submit-btn"
          >
            {loading ? 'Processing...' : 'Get the Deck'}
          </button>
        </form>

        <p className="text-gray-600 text-xs mt-4 text-center">We respect your privacy. No spam, ever.</p>
      </div>
    </div>
  );
}
